import type { ZodError } from 'zod'

import { Brand } from '@awazevr/design-system.components.awaze-theme-provider'
import {
  getExperimentVariationKey,
  getExperimentVariables,
} from '@awaze/mfe-common.lib.optimizely'
import { OPTIMIZELY_FLAGS_ENUM } from 'src/constants'
import { OptimizelyData } from 'src/types'
import { CampaignCopySchemaOutput, CampaignCopySchemaRequiring } from './schema'

type AgeCountdownBannerParams = {
  brand: Brand
  language: string
  optimizelyData: OptimizelyData | undefined
}

type AgeCountdownBannerResult = {
  bannerData: CampaignCopySchemaOutput['banner_text'][Brand][string] | null
  error: ZodError<CampaignCopySchemaOutput> | null
  isIn2693BannerExp: boolean
}

export const ageCountdownBanner = ({
  brand,
  language,
  optimizelyData,
}: AgeCountdownBannerParams): AgeCountdownBannerResult => {
  if (optimizelyData?.decisions === undefined) {
    return { bannerData: null, error: null, isIn2693BannerExp: false }
  }

  const countdownBannerExp = getExperimentVariationKey(
    optimizelyData.decisions,
    OPTIMIZELY_FLAGS_ENUM.AGE_COUNTDOWN_BANNER,
  )

  const isIn2693BannerExp = countdownBannerExp === 'variant_a'

  if (!isIn2693BannerExp) {
    return { bannerData: null, error: null, isIn2693BannerExp: false }
  }

  const bannerVariantData = getExperimentVariables(
    optimizelyData.decisions,
    OPTIMIZELY_FLAGS_ENUM.AGE_COUNTDOWN_BANNER,
  )

  const bannerVarianDataValidated = CampaignCopySchemaRequiring(
    brand,
    language,
  ).safeParse(bannerVariantData)

  if (!bannerVarianDataValidated.success) {
    return {
      bannerData: null,
      error: bannerVarianDataValidated.error,
      isIn2693BannerExp: true,
    }
  }

  const bannerData = bannerVarianDataValidated.data.banner_text[brand][language]

  return { bannerData, error: null, isIn2693BannerExp: true }
}
